export default "__VITE_ASSET__9Y_2N5oI__"